/**
 * @fileoverview gRPC-Web generated client stub for com.royalhaskoningdhv.mondriaan.proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.10
// source: soilInvestigation.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var cpt_pb = require('./cpt_pb.js')

var borehole_pb = require('./borehole_pb.js')

var location_pb = require('./location_pb.js')
const proto = {};
proto.com = {};
proto.com.royalhaskoningdhv = {};
proto.com.royalhaskoningdhv.mondriaan = {};
proto.com.royalhaskoningdhv.mondriaan.proto = require('./soilInvestigation_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
 *   !proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList>}
 */
const methodDescriptor_SoilInvestigationService_getDetailedSoilInvestigationInfo = new grpc.web.MethodDescriptor(
  '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getDetailedSoilInvestigationInfo',
  grpc.web.MethodType.UNARY,
  proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
  proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList,
  /**
   * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList.deserializeBinary
);


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServiceClient.prototype.getDetailedSoilInvestigationInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getDetailedSoilInvestigationInfo',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_getDetailedSoilInvestigationInfo,
      callback);
};


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationList>}
 *     Promise that resolves to the response
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServicePromiseClient.prototype.getDetailedSoilInvestigationInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getDetailedSoilInvestigationInfo',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_getDetailedSoilInvestigationInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
 *   !proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList>}
 */
const methodDescriptor_SoilInvestigationService_getSimpleSoilInvestigations = new grpc.web.MethodDescriptor(
  '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getSimpleSoilInvestigations',
  grpc.web.MethodType.UNARY,
  proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
  proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList,
  /**
   * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList.deserializeBinary
);


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServiceClient.prototype.getSimpleSoilInvestigations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getSimpleSoilInvestigations',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_getSimpleSoilInvestigations,
      callback);
};


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.royalhaskoningdhv.mondriaan.proto.SimpleSoilInvestigationList>}
 *     Promise that resolves to the response
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServicePromiseClient.prototype.getSimpleSoilInvestigations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/getSimpleSoilInvestigations',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_getSimpleSoilInvestigations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_SoilInvestigationService_deleteSoilInvestigation = new grpc.web.MethodDescriptor(
  '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/deleteSoilInvestigation',
  grpc.web.MethodType.UNARY,
  proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServiceClient.prototype.deleteSoilInvestigation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/deleteSoilInvestigation',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_deleteSoilInvestigation,
      callback);
};


/**
 * @param {!proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationIdList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationServicePromiseClient.prototype.deleteSoilInvestigation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.royalhaskoningdhv.mondriaan.proto.SoilInvestigationService/deleteSoilInvestigation',
      request,
      metadata || {},
      methodDescriptor_SoilInvestigationService_deleteSoilInvestigation);
};


module.exports = proto.com.royalhaskoningdhv.mondriaan.proto;

